/**
 * Returns the appropriate location set from LocationsData based on whether
 * any filters are currently active.
 */
const getDisplayLocations = (locationsData) => {
	const hasFilters = locationsData.hasActiveFilters?.() ?? false;
	return hasFilters
		? locationsData.getFilteredLocations() || []
		: locationsData.getLocations() || [];
};

export default getDisplayLocations;
